module.exports = "<app-network-status></app-network-status>\r\n\r\n<p>command-center works!</p>\r\n"